// extracted by mini-css-extract-plugin
export default {"technical":"GuideType_technical__dvY3y","pedagogical":"GuideType_pedagogical__fpW0w"};